import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import { useApiClient } from './useApiClient';

export interface VorgaengeAlerting {
  count: number;
  byStatus: {
    WARTEND: number;
    LAUFEND: number;
  };
  thresholdHours: number;
}

export const useVorgaengeAlerting = () => {
  const { axiosInstance } = useApiClient();

  return useQuery<VorgaengeAlerting>({
    queryKey: queryKeys.vorgaenge.alerting(),
    queryFn: async () => {
      const response = await axiosInstance.get<VorgaengeAlerting>(
        '/vorgaenge-alerting',
      );
      return response.data;
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
};
